import React from 'react';
import Relay from 'react-relay';

import SportTable from '../../components/SportTable';
import Button from '../../components/Button';
import SportPanel from '../../components/SportPanel';

import NewSportMutation from '../../mutations/Sport/NewSportMutation';
import UpdateSportMutation from '../../mutations/Sport/UpdateSportMutation';

import Config from '../../Config';


class SportList extends React.Component {
  
  constructor(props) {
    super(props);
  }

  componentWillMount(){
  }

  _getLang(){
    let lang = Config.lang;

    if(this.props.location && this.props.location.state){
      lang = this.props.location.state.lang;
    }

    return lang;
  }

  onNewSportClick(){
    let path = '/sports/add'; 
    this.props.router.push({
      pathname : path,
      state :{
        sport : null,
        langList: this.props.viewer.supportedLanguages,
        relay:this.props.relay,
        lang: this._getLang(),
      }
    })
  }

  onEditSportClick(item, index){

    if(item == this.props.location.state.sport){
      return;
    }
console.log(item);
    let path = '/sports/edit/'+item.node.id;
    this.props.router.push({
      pathname : path,
      state :{
        sportStatusList: this.props.sportStatusList.enumValues,
        langList: this.props.viewer.supportedLanguages,
        relay:this.props.relay,
        lang: this._getLang(),
      }
    })
  }

  render() {
    let lang = this._getLang();
    const sports = this.props.viewer.sports.edges;
    return (
      <div>
        <div className="row" style={{marginTop:20}}>
          <Button text="New Sport" onClick={this.onNewSportClick.bind(this)} color="btn-success" />
        </div>
        <div style={{marginTop:20}}>
            <SportTable 
              dataSource={sports} 
              lang={lang}
              onItemClick={this.onEditSportClick.bind(this)}/>
        </div>
      </div>
    );

  }

}

SportList.propTypes = ({
  viewer: React.PropTypes.object.isRequired,
  relay: React.PropTypes.object.isRequired,
  children: React.PropTypes.node,
});

export default Relay.createContainer(SportList, {
  fragments: {
    sportStatusList: () => Relay.QL`fragment on __Type {enumValues {name description}}`,
    viewer: () => Relay.QL`
      fragment on Viewer {
        supportedLanguages,
        sports (last: 1000) {
          edges {
            node {
              id,
              name {
                FR,
                EN,
                DE,
                ES
              },
              positions {
                FR,
                EN,
                DE,
                ES
              },
              logo,
              certificates {
                name {
                  FR,
                  EN,
                  DE,
                  ES
                }
              },
              levels {
                FR {
                  name,
                  description,
                  skillLevel
                },
                EN {
                  name,
                  description,
                  skillLevel
                },
                DE {
                  name,
                  description,
                  skillLevel
                },
                ES {
                  name,
                  description,
                  skillLevel
                },
              }
              status,
            }
          }
        }
      }
    `,
  }
});







// WEBPACK FOOTER //
// ./src/pages/Sport/SportsList.js